import { change, untouch } from 'redux-form';

export const handleClinicalInformationIsNotProvided = (formValues, dispatchFunction) => {
  if (formValues === undefined) {
    return;
  }
  Object.keys(formValues).forEach(field => {
    dispatchFunction(change('caseClinicalInformation', field, null));
    dispatchFunction(untouch('caseClinicalInformation', field));
  });
};
